import { Typography } from '@iheartjane/reefer';

interface MultiParagraphProps {
  children: string;
}

export const MultiParagraph = ({ children }: MultiParagraphProps) => {
  return (
    <Typography as="div" color="text-main">
      {children
        .replace(/\r\n?/g, '\n')
        .split(/\n/)
        .map((s) => s.trim())
        .map((t, index) => {
          if (t.length === 0) return <br key={index} />;
          return <p key={index}>{t}</p>;
        })}
    </Typography>
  );
};
